import React, { useState, Children } from 'react';
import { useFormContext } from 'react-hook-form';
import { PlusIcon, TrashIcon } from 'lucide-react';
const Beneficiaries = () => {
  const {
    register,
    watch
  } = useFormContext();
  const [specificGifts, setSpecificGifts] = useState([{
    id: 1,
    item: '',
    recipient: ''
  }]);
  const addGift = () => {
    const newId = specificGifts.length > 0 ? Math.max(...specificGifts.map(g => g.id)) + 1 : 1;
    setSpecificGifts([...specificGifts, {
      id: newId,
      item: '',
      recipient: ''
    }]);
  };
  const removeGift = (id: number) => {
    setSpecificGifts(specificGifts.filter(gift => gift.id !== id));
  };
  return <div className="space-y-8" data-id="element-458">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-459">
        <p className="text-slate-700" data-id="element-460">
          Please provide information about how you would like your assets to be
          distributed after your death.
        </p>
      </div>

      {/* Specific Gifts/Bequests */}
      <div className="space-y-4" data-id="element-461">
        <div className="flex justify-between items-center" data-id="element-462">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-463">
            Specific Gifts or Bequests (Optional)
          </h3>
          <button type="button" onClick={addGift} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-464">
            <PlusIcon size={16} className="mr-1" data-id="element-465" />
            Add Gift
          </button>
        </div>
        <p className="text-sm text-slate-600 mb-4" data-id="element-466">
          List any specific items or amounts you wish to leave to particular
          individuals.
        </p>

        {specificGifts.map((gift, index) => <div key={gift.id} className="p-4 bg-slate-50 rounded-md" data-id="element-467">
            <div className="flex justify-between items-center mb-3" data-id="element-468">
              <h4 className="font-medium" data-id="element-469">Gift {index + 1}</h4>
              {specificGifts.length > 1 && <button type="button" onClick={() => removeGift(gift.id)} className="text-red-500 hover:text-red-700" data-id="element-470">
                  <TrashIcon size={16} data-id="element-471" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-472">
              <div data-id="element-473">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-474">
                  Item or Amount
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Jewelry collection, $10,000" {...register(`specificGifts.${index}.item`)} data-id="element-475" />
              </div>
              <div data-id="element-476">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-477">
                  Recipient
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter recipient's name" {...register(`specificGifts.${index}.recipient`)} data-id="element-478" />
              </div>
            </div>
          </div>)}
      </div>

      {/* Primary Beneficiaries */}
      <div className="space-y-4" data-id="element-479">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-480">
          Primary Beneficiaries
        </h3>
        <p className="text-sm text-slate-600 mb-4" data-id="element-481">
          Who should receive the residue of your estate (everything not
          specifically given away)?
        </p>

        <div data-id="element-482">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-483">
            How would you like to distribute your estate?
          </label>
          <div className="space-y-3" data-id="element-484">
            <label className="flex items-start" data-id="element-485">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="spouse" {...register('beneficiaries.distribution')} data-id="element-486" />
              <span className="ml-2 block" data-id="element-487">
                <span className="font-medium" data-id="element-488">All to spouse</span>
                <span className="text-sm text-slate-500 block mt-0.5" data-id="element-489">
                  Your entire estate goes to your spouse.
                </span>
              </span>
            </label>

            <label className="flex items-start" data-id="element-490">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="spouseThenChildren" {...register('beneficiaries.distribution')} data-id="element-491" />
              <span className="ml-2 block" data-id="element-492">
                <span className="font-medium" data-id="element-493">
                  All to spouse, then to children equally if spouse predeceases
                </span>
                <span className="text-sm text-slate-500 block mt-0.5" data-id="element-494">
                  Your entire estate goes to your spouse, but if your spouse
                  dies before you, it's divided equally among your children. If
                  you have a child who also predeceases but leaves children of
                  his or her own, then that deceased child's share would be
                  divided amongst his or her children if they have any.
                </span>
              </span>
            </label>

            <label className="flex items-start" data-id="element-495">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="children" {...register('beneficiaries.distribution')} data-id="element-496" />
              <span className="ml-2 block" data-id="element-497">
                <span className="font-medium" data-id="element-498">All to children equally</span>
                <span className="text-sm text-slate-500 block mt-0.5" data-id="element-499">
                  Your estate is divided equally among your children.
                </span>
              </span>
            </label>

            <label className="flex items-start" data-id="element-500">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="custom" {...register('beneficiaries.distribution')} data-id="element-501" />
              <span className="ml-2 block" data-id="element-502">
                <span className="font-medium" data-id="element-503">Custom distribution</span>
                <span className="text-sm text-slate-500 block mt-0.5" data-id="element-504">
                  Specify your own distribution plan.
                </span>
              </span>
            </label>
          </div>
        </div>

        {watch('beneficiaries.distribution') === 'custom' && <div className="mt-4" data-id="element-505">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-506">
              Custom Distribution Plan
            </label>
            <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={4} placeholder="Describe how you want your estate distributed (e.g., 50% to spouse, 25% to each child)" {...register('beneficiaries.customPlan')} data-id="element-507" />
          </div>}
      </div>

      {/* Alternate Beneficiaries */}
      <div className="space-y-4" data-id="element-508">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-509">
          Alternate Beneficiaries
        </h3>
        <p className="text-sm text-slate-600 mb-4" data-id="element-510">
          Who should receive your estate if none of your primary beneficiaries
          survive you?
        </p>

        <div data-id="element-511">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-512">
            Alternate Beneficiaries
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Enter names and relationships of alternate beneficiaries" {...register('beneficiaries.alternates')} data-id="element-513" />
          <p className="text-sm text-slate-500 mt-1" data-id="element-514">
            Examples: siblings, nieces/nephews, parents, charities
          </p>
        </div>
      </div>

      {/* Age of Inheritance */}
      <div className="space-y-4" data-id="element-515">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-516">
          Age of Inheritance
        </h3>

        <div data-id="element-517">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-518">
            At what age should beneficiaries under 18 receive their inheritance?
          </label>
          <div className="flex items-center space-x-4" data-id="element-519">
            <label className="inline-flex items-center" data-id="element-520">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="18" {...register('beneficiaries.ageOfInheritance')} data-id="element-521" />
              <span className="ml-2" data-id="element-522">18</span>
            </label>
            <label className="inline-flex items-center" data-id="element-523">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="21" {...register('beneficiaries.ageOfInheritance')} data-id="element-524" />
              <span className="ml-2" data-id="element-525">21</span>
            </label>
            <label className="inline-flex items-center" data-id="element-526">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="25" {...register('beneficiaries.ageOfInheritance')} data-id="element-527" />
              <span className="ml-2" data-id="element-528">25</span>
            </label>
            <label className="inline-flex items-center" data-id="element-529">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="custom" {...register('beneficiaries.ageOfInheritance')} data-id="element-530" />
              <span className="ml-2" data-id="element-531">Other</span>
            </label>
          </div>

          {watch('beneficiaries.ageOfInheritance') === 'custom' && <div className="mt-3" data-id="element-532">
              <input type="number" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter age" {...register('beneficiaries.customAge')} data-id="element-533" />
            </div>}
          <p className="text-sm text-slate-500 mt-2" data-id="element-534">
            Until this age is reached, the inheritance will be held in trust and
            managed by trustees.
          </p>
        </div>
      </div>

      {/* Guardians/Custodians */}
      <div className="space-y-4" data-id="element-535">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-536">
          Guardians for Minor Children
        </h3>

        <div data-id="element-537">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-538">
            Guardian's Name
          </label>
          <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter guardian's name" {...register('guardians.name')} data-id="element-539" />
        </div>

        <div data-id="element-540">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-541">
            Alternate Guardian's Name
          </label>
          <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter alternate guardian's name" {...register('guardians.alternate')} data-id="element-542" />
        </div>

        <div data-id="element-543">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-544">
            Monthly Allowance for Guardians (Optional)
          </label>
          <div className="relative" data-id="element-545">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-546">
              <span className="text-slate-500" data-id="element-547">$</span>
            </div>
            <input type="number" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Amount" {...register('guardians.monthlyAllowance')} data-id="element-548" />
          </div>
        </div>
      </div>
    </div>;
};
export default Beneficiaries;